module.exports = __webpack_public_path__ + "img/CYP-image-1.4ec5fe8a.png";